import moment from 'moment'
import 'moment/locale/uk'
import documents from './to_replace/documens'
import offers from './to_replace/offers'
import sales from './to_replace/sales'
import transactions from './to_replace/transactions'
import transfers from './to_replace/transfers'
import defaults from './to_replace/default'
import txHistoryView from './views/tx-history_view'
import withdrawView from './views/withdrawal_view'
import topupView from './views/topup_view'
import signupView from './views/signup_view'
import loginView from './views/login_view'
import ruStrings from './views/ru/ru_all'
import uaStrings from './views/ua/ua_all'
import enStrings from './views/en_all'
import saleView from './views/sale_view'
import labels from './views/labels'
import inactivitymessage from './views/inactivity_message'
import settingsView from './views/settings_view'
import dashboardView from './views/dashboard_view'
import transfersView from './views/transfers_view'
import modals from './views/modals'
import verification from './views/verification_view'
import fileUpload from './views/file-upload'
import trade from './views/trade_view'
import companyView from './views/company_view'
import limitsView from './views/limits_view'
import fees from './views/fees'
import common from './views/common'
import auth from './views/auth_view'
import contactUs from './views/contact_us'
import dividendsView from './views/dividends_view'
import errors from './views/errors'
import contracts from './views/contracts'
import {TX_STATES} from '../const/tx_states.const'

import { formatConvertedCurrency, formatCurrency, formatNumber } from './numbers'

import Polyglot from 'node-polyglot'
import langar from 'vee-validate/dist/locale/ar'
import langbg from 'vee-validate/dist/locale/bg'
import langca from 'vee-validate/dist/locale/ca'
import langcs from 'vee-validate/dist/locale/cs'
import langda from 'vee-validate/dist/locale/da'
import langde from 'vee-validate/dist/locale/de'
import langel from 'vee-validate/dist/locale/el'
import langen from 'vee-validate/dist/locale/en'
import langes from 'vee-validate/dist/locale/es'
import langet from 'vee-validate/dist/locale/et'
import langeu from 'vee-validate/dist/locale/eu'
import langfa from 'vee-validate/dist/locale/fa'
import langfi from 'vee-validate/dist/locale/fi'
import langfr from 'vee-validate/dist/locale/fr'
import langhe from 'vee-validate/dist/locale/he'
import langhr from 'vee-validate/dist/locale/hr'
import langhu from 'vee-validate/dist/locale/hu'
import langid from 'vee-validate/dist/locale/id'
import langit from 'vee-validate/dist/locale/it'
import langja from 'vee-validate/dist/locale/ja'
import langka from 'vee-validate/dist/locale/ka'
import langko from 'vee-validate/dist/locale/ko'
import langlt from 'vee-validate/dist/locale/lt'
import langmsMY from 'vee-validate/dist/locale/ms_MY'
import langnbNO from 'vee-validate/dist/locale/nb_NO'
import langnl from 'vee-validate/dist/locale/nl'
import langnnNO from 'vee-validate/dist/locale/nn_NO'
import langpl from 'vee-validate/dist/locale/pl'
import langptBR from 'vee-validate/dist/locale/pt_BR'
import langptPT from 'vee-validate/dist/locale/pt_PT'
import langro from 'vee-validate/dist/locale/ro'
import langru from 'vee-validate/dist/locale/ru'
import langsk from 'vee-validate/dist/locale/sk'
import langsl from 'vee-validate/dist/locale/sl'
import langsr from 'vee-validate/dist/locale/sr'
import langsv from 'vee-validate/dist/locale/sv'
import langth from 'vee-validate/dist/locale/th'
import langtr from 'vee-validate/dist/locale/tr'
import languk from 'vee-validate/dist/locale/uk'
import langvi from 'vee-validate/dist/locale/vi'
import langzhCN from 'vee-validate/dist/locale/zh_CN'
import langzhTW from 'vee-validate/dist/locale/zh_TW'
import VeeValidate from 'vee-validate'

const veeDictionary = { ar: langar,
  bg: langbg,
  ca: langca,
  cs: langcs,
  da: langda,
  de: langde,
  el: langel,
  en: langen,
  es: langes,
  et: langet,
  eu: langeu,
  fa: langfa,
  fi: langfi,
  fr: langfr,
  he: langhe,
  hr: langhr,
  hu: langhu,
  id: langid,
  it: langit,
  ja: langja,
  ka: langka,
  ko: langko,
  lt: langlt,
  ms_MY: langmsMY,
  nb_NO: langnbNO,
  nl: langnl,
  nnNO: langnnNO,
  pl: langpl,
  pt_BR: langptBR,
  pt_PT: langptPT,
  ro: langro,
  ru: langru,
  sk: langsk,
  sl: langsl,
  sr: langsr,
  sv: langsv,
  th: langth,
  tr: langtr,
  uk: languk,
  vi: langvi,
  zh_CN: langzhCN,
  zh_TW: langzhTW
}

const polyglot = new Polyglot()

const dictionary = {
  ...enStrings,
  ...auth,
  ...documents,
  ...offers,
  ...sales,
  ...transactions,
  ...transfers,
  ...loginView,
  ...saleView,
  ...signupView,
  ...withdrawView,
  ...topupView,
  ...labels,
  ...inactivitymessage,
  ...txHistoryView,
  ...settingsView,
  ...transfersView,
  ...labels,
  ...modals,
  ...defaults,
  ...dashboardView,
  ...verification,
  ...fileUpload,
  ...trade,
  ...companyView,
  ...limitsView,
  ...common,
  ...fees,
  ...contactUs,
  ...dividendsView,
  ...errors,
  ...contracts
}

export function getCookie (cname) {
  var name = cname + '='
  var decodedCookie = decodeURIComponent(document.cookie)
  var ca = decodedCookie.split(';')
  for (var i = 0; i < ca.length; i++) {
    var c = ca[i]
    while (c.charAt(0) === ' ') {
      c = c.substring(1)
    }
    if (c.indexOf(name) === 0) {
      return c.substring(name.length, c.length)
    }
  }
  return ''
}

export function setCookie (cname, cvalue, exdays) {
  var d = new Date()
  d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000))
  var expires = 'expires=' + d.toUTCString()
  document.cookie = cname + '=' + cvalue + ';' + expires + ';path=/'
}

export function setLang (name) {
  setCookie('lang', name, 3650)
}

export function setLangAskReload (name) {
  setLang(name)
  location.reload()
}

export function langByCookie () {
  let locale = getCookie('lang')
  let redirectedLocale = getCookie('redirectLang')
  if (redirectedLocale && redirectedLocale !== locale) {
    locale = redirectedLocale
    setLang(redirectedLocale)
  }
  if (locale === '') {
    locale = 'en'
  }
  return locale
}

const ruDictionary = {
  ...dictionary,
  ...ruStrings
}

const uaDictionary = {
  ...dictionary,
  ...uaStrings
}

let usedDict = dictionary
if (langByCookie() === 'ru') {
  usedDict = ruDictionary
} else if (langByCookie() === 'ua') {
  usedDict = uaDictionary
}
moment.locale(langByCookie() === 'ua' ? 'uk' : langByCookie())

export function humanizePastDate (date) {
  return moment(date).calendar(null, {
    sameDay: usedDict.date_sameDay,
    lastDay: usedDict.date_lastDay,
    lastWeek: usedDict.date_lastWeek,
    sameElse: usedDict.date_sameElse
  })
}
export function humanizeDays (day) {
  return moment.duration(day, 'seconds').humanize(false)
}

VeeValidate.Validator.localize(langByCookie(), veeDictionary[langByCookie()])
polyglot.extend(usedDict)

export const i18n = {
  ...Object.keys(usedDict)
    .reduce((obj, key) => {
      obj[key] = (opts) => polyglot.t(key, opts)
      return obj
    }, {}),
  n: formatNumber(),
  c: formatCurrency(),
  cc: formatConvertedCurrency(),
  d: humanizePastDate,
  hd: humanizeDays,
  tx_state: function (s) {
    return s === TX_STATES.confirm ? i18n.tx_state_confirm()
      : s === TX_STATES.pending ? i18n.tx_state_pending()
        : s === TX_STATES.success ? i18n.tx_state_success()
          : s === TX_STATES.failed ? i18n.tx_state_failed()
            : s === TX_STATES.rejected ? i18n.tx_state_rejected()
              : s === TX_STATES.fully_matched ? i18n.tx_state_fully_matched() : s
  }
}



// WEBPACK FOOTER //
// ./src/js/i18n/index.js